import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const homeSlice = createApi({
    reducerPath: "homeSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: commonBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log("token", token);
                headers.set("Authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getBanners: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/webControll/all-banners?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            
            transformResponse: (response) => response,

        }),
        // ✅ Add New Category
        addbanners: builder.mutation({
            query: (body) => ({
                url: "/webControll/banners",
                method: "PUT",
                body,
            }),
        }),


    }),
});

export const {
    useGetBannersQuery,
    useAddbannersMutation
} = homeSlice;